import LinkWrapper from "../../../../elements/link-wrapper/link-wrapper";
import { THeaderV2Props } from "../../header-v2";
import styles from "./desktop-header.module.less";
import { useEffect, useState } from "react";
import DesktopMenuModal from "../desktop-menu-modal/desktop-menu-modal";
import DesktopMenuModalContent from "../desktop-menu-modal-content/desktop-menu-modal-content";
import EventAggregator from "../../../../../events/event-aggregator";
import { isArrayWithItems } from "../../../../../helpers";
import { useTranslation } from "react-i18next";

type TDesktopHeaderProps = Omit<THeaderV2Props, "mobileHeaderLinks"> & {
  logoUrl: string;
};

const DesktopHeader = ({ logoUrl, menuItems, featureLinks, isFullscreenPage }: TDesktopHeaderProps) => {
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const currentCategory = typeof activeItem === "number" && menuItems[activeItem] ? menuItems[activeItem] : null;

  useEffect(() => {
    const onRouteUpdateEvent = EventAggregator.subscribe("onRouteUpdate", () => {
      setActiveItem(null);
    });

    return () => {
      onRouteUpdateEvent.remove();
    };
  }, []);

  const onClickCategory = (currentItemIndex: number) => {
    if (currentItemIndex === activeItem) {
      setActiveItem(null);
    } else {
      setActiveItem(currentItemIndex);
    }
  };

  const { t } = useTranslation();

  return (
    <nav
      id="desktop-nav"
      aria-label={t("HEADER_MENU_ARIA_LABEL")}
      className={["max-width-as-width padded-sides", styles.wrapper, isFullscreenPage ? styles.fullscreen : ""].join(
        " ",
      )}
    >
      <LinkWrapper ariaLabel={t("HEADER_LOGO_LINK_ARIA_LABEL")} className={styles.logoWrapper} url={"/"}>
        <img src={logoUrl} alt={"Preem logo"} className={styles.logo} />
      </LinkWrapper>
      <div className={styles.innerWrapper}>
        <div className={styles.menuItemsWrapper}>
          {menuItems.map((item, index) => {
            const isActive = activeItem === index;

            if (isArrayWithItems(item.links)) {
              return (
                <div key={index} className={styles.menuButtonWrapper}>
                  <button
                    key={index}
                    className={styles.menuButton}
                    onClick={() => {
                      onClickCategory(index);
                    }}
                  >
                    <div className={"body-s bold mb-0"}>{item.title}</div>
                    <span
                      className={[styles.icon, isActive ? "ui-icon-arrow-drop-up" : "ui-icon-arrow-drop-down"].join(
                        " ",
                      )}
                    />
                  </button>
                  {isActive && (
                    <DesktopMenuModal
                      isOpen={true}
                      close={{
                        function: () => setActiveItem(null),
                      }}
                    >
                      {currentCategory && <DesktopMenuModalContent links={currentCategory.links} />}
                    </DesktopMenuModal>
                  )}
                </div>
              );
            }

            if (item.url) {
              return (
                <LinkWrapper
                  key={index}
                  className={`${styles.menuButton} ${styles.withoutIcon} ${styles.menuLink}`}
                  url={item.url}
                >
                  <div className={"body-s bold mb-0"}>{item.title}</div>
                </LinkWrapper>
              );
            }

            return null;
          })}
        </div>
        <ul className={styles.featureLinksWrapper}>
          {featureLinks.map((featureLink, index) => (
            <li key={index}>
              <LinkWrapper className={`${styles.featureLink} body-s mb-0 dynamicIcons`} url={featureLink.url}>
                <span className={`${styles.icon} ${featureLink.icon} default`} />
                <span className={`${styles.icon} ${featureLink.icon + "-filled"} hover currentPage`} />
                <span className={styles.innerLink}>{featureLink.title}</span>
              </LinkWrapper>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default DesktopHeader;
